import { useCustomPaymentField } from '../hooks/useCustomPaymentField';

// ─── Custom Payment Fields ─────────────────────────────────────────────────────────

export const useCustomPaymentId = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.paymentGuid,
        (p, v) => ({ ...p, paymentGuid: v })
    );

export const useCustomPaymentName = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.billingDetails.name,
        (p, v) => ({
            ...p,
            billingDetails: {
                ...p.billingDetails,
                name: v,
            },
        })
    );

export const useCustomPaymentPhone = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.billingDetails.phone,
        (p, v) => ({
            ...p,
            billingDetails: {
                ...p.billingDetails,
                phone: v,
            },
        })
    );

export const useCustomPaymentEmail = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.billingDetails.email,
        (p, v) => ({
            ...p,
            billingDetails: {
                ...p.billingDetails,
                email: v,
            },
        })
    );

export const useCustomPaymentAddressStreet1 = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.billingDetails.address.line1,
        (p, v) => ({
            ...p,
            billingDetails: {
                ...p.billingDetails,
                address: {
                    ...p.billingDetails.address,
                    line1: v,
                },
            },
        })
    );

export const useCustomPaymentAddressStreet2 = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.billingDetails.address.line2,
        (p, v) => ({
            ...p,
            billingDetails: {
                ...p.billingDetails,
                address: {
                    ...p.billingDetails.address,
                    line2: v,
                },
            },
        })
    );

export const useCustomPaymentAddressCity = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.billingDetails?.address.city,
        (p, v) => ({
            ...p,
            billingDetails: {
                ...p.billingDetails,
                address: {
                    ...p.billingDetails.address,
                    city: v,
                },
            },
        })
    );

export const useCustomPaymentAddressState = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.billingDetails.address.state,
        (p, v) => ({
            ...p,
            billingDetails: {
                ...p.billingDetails,
                address: {
                    ...p.billingDetails.address,
                    state: v,
                },
            },
        })
    );

export const useCustomPaymentAddressZip = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.billingDetails.address.postal_code,
        (p, v) => ({
            ...p,
            billingDetails: {
                ...p.billingDetails,
                address: {
                    ...p.billingDetails.address,
                    postal_code: v,
                },
            },
        })
    );

export const useCustomPaymentIsPropertyInArizona = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.isPropertyInArizona,
        (p, v) => ({ ...p, isPropertyInArizona: v })
    );

export const useCustomPaymentPurpose = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.paymentPurpose,
        (p, v) => ({ ...p, paymentPurpose: v })
    );

export const useCustomPaymentPropertyLoanReference = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.propertyLoanReference,
        (p, v) => ({ ...p, propertyLoanReference: v })
    );

export const useCustomPaymentAmount = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.amount,
        (p, v) => ({ ...p, amount: v })
    );

export const useCustomPaymentCardNumber = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.cardNumber,
        (p, v) => ({ ...p, cardNumber: v })
    );

export const useCustomPaymentCardFocus = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.cardFocus,
        (p, v) => ({ ...p, cardFocus: v })
    );

export const useCustomPaymentCardType = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.cardType,
        (p, v) => ({ ...p, cardType: v })
    );

export const useCustomPaymentCardMonthYear = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.expirationDate,
        (p, v) => ({ ...p, expirationDate: v })
    );

export const useCustomPaymentCVC = (paymentGuid: string) =>
    useCustomPaymentField(
        paymentGuid,
        (p) => p.cvc,
        (p, v) => ({ ...p, cvc: v })
    );
